import styled from '@emotion/styled';

// 메인 컨테이너
export const FormPageContainer = styled.div`
  padding: 1rem;
  max-width: 800px;
  margin: 0 auto;
`;

// 폼 필드
export const FormField = styled.div`
  margin-bottom: 0.75rem;
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: var(--theme-text-secondary);
  }
  &:focus-within label {
    color: var(--theme-primary-dark, var(--theme-primary));
  }
`;

// 액션 버튼 컨테이너
export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
`;

// 강의 관리 컨테이너
export const CourseManagementContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

// 강의 목록 섹션
export const CourseListSection = styled.div`
  border: 1px solid var(--theme-border-light);
  border-radius: 8px;
  padding: 1.5rem;
  background-color: var(--theme-bg-subtle);
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  h3 {
    width: 100%;
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1.1rem;
    color: var(--theme-text-primary);
  }
`;

// 사용 가능한 강의 카드 래퍼
export const AvailableCourseCardWrapper = styled.div`
  margin-bottom: 0;
  position: relative;
  .course-card-container { pointer-events: none; }
  .add-button-on-card {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 10;
  }
`;

// 드래그 핸들
export const DragHandle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  padding: 0.25rem 0.5rem;
  color: var(--theme-text-muted);
  touch-action: none;
  user-select: none;
  border-radius: 4px;
  &:hover {
    color: var(--theme-text-primary);
    background-color: var(--theme-bg-hover);
  }
`;

// 선택된 강의 아이템
export const SelectedCourseItemSC = styled.div<{ isDragging?: boolean }>`
  border: 1px solid var(--theme-border-lighter);
  border-radius: 4px;
  margin-bottom: 0.5rem;
  background-color: var(--theme-bg-paper);
  position: relative;
  opacity: ${(props) => (props.isDragging ? 0.4 : 1)};
  box-shadow: ${(props) => (props.isDragging ? '0 4px 8px rgba(0,0,0,0.1)' : 'none')};
  transition: box-shadow 0.2s, transform 0.2s;
  flex: 1 1 260px;
  min-width: 220px;
  max-width: 100%;
  .selected-course-card-container { pointer-events: none; min-width: 0; }
  .drag-handle-overlay {
    position: absolute; top: 50%; left: 8px; transform: translateY(-50%); z-index: 10;
    background-color: var(--theme-bg-surface, #ffffff); border: 1px solid var(--theme-border-light, #e0e0e0);
    border-radius: 4px; padding: 0.25rem 0.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    color: var(--theme-text-secondary);
    &:hover { background-color: var(--theme-bg-hover, #f0f0f0); color: var(--theme-text-primary); }
  }
  .order-overlay {
    position: absolute; top: 8px; left: 8px; z-index: 30;
    background-color: var(--theme-primary-light, #3b82f6); color: var(--theme-primary-contrast-text, white);
    border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;
    font-size: 0.75rem; font-weight: bold; box-shadow: 0 1px 2px rgba(0,0,0,0.15);
  }
  .remove-button-overlay { position: absolute; top: 8px; right: 8px; z-index: 10; }
`;

// 강의 검색 및 목록 레이아웃
export const CourseSearchAndListLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

// 검색 입력 래퍼
export const SearchInputWrapper = styled.div`
  position: relative;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
`;

// 검색 결과 오버레이
export const SearchResultsOverlay = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 500px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid var(--theme-border-light);
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
  margin-top: 0;

  .status-display-in-overlay {
    padding: 1rem;
    margin: 0;
    border: none;
    background-color: transparent;
    width: 100%;
    min-width: unset;
    max-width: 100%;
    font-size: 0.8rem;
  }

  .status-display-in-overlay > div:first-of-type {
    margin-bottom: 0.5rem;
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;